import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dashboard-v2-kpis',
  templateUrl: './dashboard-kpis.component.html',
})
export class DashboardV2KpisComponent {
  @Input() kpis: any[] = [];
  @Output() kpiClick = new EventEmitter<any>();
}
